import { createRoot } from 'react-dom/client';
import { Router, Route, Switch } from 'react-router-dom';
import history from '../../common/utils/history';
import Top from './top';
import Error from './error';

const root = createRoot(document.getElementById('root'));
root.render(
  <Router history={history}>
    {/* <Route path={contentPath}> */}
    <Switch>
      <Route exact path="/pages/inquiry" component={Top} />
      <Route path="/pages/inquiry/error" component={Error} />
      <Route path="*" component={Top} />
    </Switch>
    {/* </Route> */}
  </Router>
);
